import React from 'react';

const PrivacyPage = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Privacy Policy for PteroBuddy</h1>
      <p><strong>Effective Date:</strong> [Insert Date]</p>

      <p>
        At PteroBuddy, we prioritize your privacy and the security of your data. This Privacy Policy explains how we collect, use, and protect the information you provide while using PteroBuddy, a Discord bot designed to integrate with the Pterodactyl panel.
      </p>
      <p>By using PteroBuddy, you agree to the practices outlined in this Privacy Policy.</p>

      <h2>1. Information We Collect</h2>
      <p>To provide its features, PteroBuddy collects the following data:</p>
      <ul>
        <li><strong>Discord Information:</strong>
          <ul>
            <li>Server IDs: To identify and configure servers where the bot is used.</li>
            <li>User IDs: To associate actions and permissions with specific users.</li>
            <li>Role IDs: To manage permissions for bot commands.</li>
            <li>Channel IDs: For logging bot actions or interactions.</li>
          </ul>
        </li>
        <li><strong>Pterodactyl Information:</strong>
          <ul>
            <li>User Credentials: Encrypted Pterodactyl API keys and user account details.</li>
            <li>Server Information: Names, IDs, and configurations of servers managed via Pterodactyl.</li>
            <li>Action Logs: Records of bot activities such as server creation or deletion.</li>
          </ul>
        </li>
        <li><strong>General Data:</strong>
          <ul>
            <li>Command Usage Logs: Tracks commands issued to improve bot functionality.</li>
            <li>Timestamps: To log the timing of events for troubleshooting and auditing.</li>
          </ul>
        </li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <p>We use the collected data to:</p>
      <ul>
        <li>Provide core functionalities such as user and server management via Pterodactyl.</li>
        <li>Maintain security and ensure proper use of the bot.</li>
        <li>Enable server administrators to manage bot access and permissions.</li>
        <li>Analyze command usage patterns to improve performance and features.</li>
      </ul>

      <h2>3. How We Protect Your Data</h2>
      <p>We implement the following security measures to protect your data:</p>
      <ul>
        <li>Encryption: All sensitive data, such as API keys, is encrypted during storage and transmission.</li>
        <li>Access Control: Only authorized administrators can access stored data.</li>
        <li>Data Minimization: We collect only the data necessary for the bot’s functionality.</li>
        <li>Regular Security Reviews: We periodically review and update our security practices.</li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>We retain your data only as long as necessary for the bot’s operation. Upon removing PteroBuddy from your server, all associated data is automatically deleted. Users can also request data deletion by contacting our support team.</p>

      <h2>5. Data Sharing</h2>
      <p>PteroBuddy does not sell, rent, or share your data with third parties. Data is used exclusively for:</p>
      <ul>
        <li>Providing bot functionality.</li>
        <li>Troubleshooting and improving services.</li>
      </ul>

      <h2>6. Your Rights</h2>
      <p>As a user, you have the right to:</p>
      <ul>
        <li>Access the data we store about you or your server.</li>
        <li>Request correction of inaccurate or outdated information.</li>
        <li>Request deletion of your server’s data.</li>
        <li>Restrict or object to the processing of your data.</li>
      </ul>
      <p>To exercise your rights, contact us using the information in the Contact Us section.</p>

      <h2>7. Updates to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. Significant changes will be announced in our Discord support server or through bot notifications. The updated policy will also be available here.</p>

      <h2>8. Contact Us</h2>
      <p>If you have questions or concerns about our Privacy Policy or your data, feel free to reach out:</p>
      

      
      <p>© 2024 PteroBuddy. All rights reserved.</p>
    </div>
  );
};

export default PrivacyPage;
